import CityPageTemplate from "../city-template/CityPageTemplate";
import { delawareConfig } from "./data";

export default function DelawarePage() {
  return <CityPageTemplate config={delawareConfig} />;
}